import { render } from "./CatalogHead.vue?vue&type=template&id=c50d3cc6&scoped=true"
import script from "./CatalogHead.vue?vue&type=script&lang=js"
export * from "./CatalogHead.vue?vue&type=script&lang=js"

import "./CatalogHead.vue?vue&type=style&index=0&id=c50d3cc6&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50d3cc6"]])

export default __exports__